import React, { useState } from 'react';
import { toast } from 'sonner';
import { useApp } from '../../context/AppContext';
import { KELATE_BANK, KELATE_TNG, fmtRM2 } from '../../data/mockData';
import { ImageUpload } from './ImageUpload';

const AMOUNTS = [10, 20, 50, 100, 200];

export function TopUpForm({ ownerType, ownerKey, ownerName }) {
  const { requestTopUp } = useApp();
  const [amount, setAmount] = useState(50);
  const [custom, setCustom] = useState('');
  const [method, setMethod] = useState('BANK');
  const [reference, setReference] = useState('');
  const [proof, setProof] = useState('');
  const finalAmount = custom ? Number(custom) : amount;
  const submit = () => {
    if (!finalAmount || finalAmount < 5) return toast.error('Minimum top-up is RM5');
    if (!reference.trim()) return toast.error('Enter your transfer reference number');
    requestTopUp({ ownerType, ownerKey, ownerName, amount: finalAmount, method, reference: reference.trim(), proof });
    setReference('');
    setProof('');
    setCustom('');
  };
  return (
    <div data-testid="topup-form" className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {AMOUNTS.map((a) => (
          <button key={a} type="button" data-testid={`topup-chip-${a}`} onClick={() => { setAmount(a); setCustom(''); }}
            className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${!custom && amount === a ? 'border-kelate-darkwood bg-kelate-darkwood text-kelate-surface' : 'border-kelate-line bg-kelate-bg text-kelate-soft hover:border-kelate-wood'}`}>
            RM{a}
          </button>
        ))}
        <input data-testid="topup-custom-amount" type="number" min="5" placeholder="Custom RM" value={custom} onChange={(e) => setCustom(e.target.value)}
          className="h-9 w-28 rounded-full border border-kelate-line bg-kelate-bg px-3 text-sm outline-none focus:border-kelate-wood" />
      </div>
      <div className="flex gap-2">
        {[['BANK', 'Bank Transfer'], ['TNG', 'TNG eWallet']].map(([id, label]) => (
          <button key={id} type="button" data-testid={`topup-method-${id.toLowerCase()}`} onClick={() => setMethod(id)}
            className={`flex-1 rounded-xl border px-3 py-2.5 text-sm font-medium transition-colors ${method === id ? 'border-kelate-darkwood bg-secondary/60 text-kelate-ink' : 'border-kelate-line text-kelate-soft hover:border-kelate-wood'}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="rounded-xl bg-secondary/50 px-3.5 py-3 font-mono text-xs leading-relaxed text-kelate-ink" data-testid="topup-bank-details">
        {method === 'BANK' ? (
          <>{KELATE_BANK.holder}<br />{KELATE_BANK.bank ? `${KELATE_BANK.bank} ` : ''}{KELATE_BANK.account}<br />Amount: {fmtRM2(finalAmount || 0)}</>
        ) : (
          <>{KELATE_TNG.holder}<br />TNG eWallet: {KELATE_TNG.number}<br />Amount: {fmtRM2(finalAmount || 0)}</>
        )}
      </div>
      <input data-testid="topup-reference" placeholder="Transfer reference / receipt no." value={reference} onChange={(e) => setReference(e.target.value)}
        className="h-10 w-full rounded-xl border border-kelate-line bg-kelate-bg px-3 text-sm outline-none focus:border-kelate-wood" />
      <ImageUpload value={proof} onChange={setProof} label="Payment proof (receipt screenshot)" hint="Optional but speeds up approval" testId="topup-proof" aspect="banner" />
      <button data-testid="topup-submit" onClick={submit} className="w-full rounded-xl bg-kelate-darkwood py-2.5 text-sm font-medium text-kelate-surface hover:bg-kelate-wood">
        Submit Top-Up Request {finalAmount ? `(${fmtRM2(finalAmount)})` : ''}
      </button>
      <p className="text-[11px] text-kelate-soft">KELATE verifies your transfer and credits your wallet. You will get a notification once approved.</p>
    </div>
  );
}
